import { createAction, props } from '@ngrx/store';
import { MediaPlayerState } from './enum/media-player/media-player-state';
import { MediaRadio } from './objects/media-player/media-radio';
import { MediaTrack } from './objects/media-player/media-track';
import { RadioAPI } from './objects/radio-api';

// MEDIA PLAYER ACTIONS

export const playMedia = createAction(
  '[Player Component] playMedia',
  props<{ mediaContent: MediaRadio | MediaTrack }>()
);
export const pauseMedia = createAction('[Player Component] pauseMedia');
export const resumeMedia = createAction('[Player Component] resumeMedia');
export const stopMedia = createAction('[Player Component] stopMedia');
export const nextMedia = createAction('[Player Component] nextMedia');
export const previousMedia = createAction('[Player Component] previousMedia');
export const updateMediaContentGeneral = createAction(
  '[Player Component] updateMediaContentGeneral',
  props<{
    playerState: MediaPlayerState | null;
    progress: number | null;
    currentStreamTitle: string | null;
    currentStreamImageUrl: string | null;
    mediaFormat: string | null;
    audioChannels: number | null;
    bitrateFromSource: number | null;
    sampleFrequency: number | null;
  }>()
);
export const updateAudioVolume = createAction(
  '[Player Component] updateAudioVolume',
  props<{ newAudioVolume: number }>()
);
export const muteAudioVolume = createAction(
  '[Player Component] muteAudioVolume'
);
export const unmuteAudioVolume = createAction(
  '[Player Component] unmuteAudioVolume'
);
export const playMode = createAction('[Player Component] muteAudioVolume');

// RADIO API ACTIONS

export const initFetchRadios = createAction(
  '[API Component] initFetchRadios',
  props<{ countryCode: string }>()
);

export const initFetchRadiosFailed = createAction(
  '[API Component] initFetchRadiosFailed'
);
export const initFetchRadiosSuccessful = createAction(
  '[API Component] initFetchRadiosSuccessful',
  props<{ allRadios: Array<RadioAPI> }>()
);

// SEARCH ACTIONS

export const initSearchState = createAction(
  '[Search Component] initSearchState'
);
export const updateSearchState = createAction(
  '[Search Component] updateSearchState',
  props<{ isEnabled?: boolean; searchText?: string }>()
);

// SUGGESTED RADIOS ACTIONS (For PSEO and Recommendations)

export const updateSuggestedRadios = createAction(
  '[Player Component] updateSuggestedRadios',
  props<{ suggestedRadios: Array<RadioAPI> }>()
);

export const loadSuggestedRadios = createAction(
  '[Now Playing Component] loadSuggestedRadios',
  props<{ currentRadio: RadioAPI; allRadios: Array<RadioAPI> }>()
);

// OTHER ACTIONS

export const initUserCountryCode = createAction(
  '[API Component] initUserCountryCode'
);
export const initUserCountryCodeFailed = createAction(
  '[API Component] initUserCountryCodeFailed'
);
export const initUserCountryCodeSuccessful = createAction(
  '[API Component] initUserCountryCodeSuccessful',
  props<{ countryCode: string }>()
);
